export const localConfig = {
  REACT_APP_AZURE_CLIENT_ID: '1e8caacb-44dd-48f3-a57f-3cc773298903', //'267896e6-3a07-4ff1-83dd-1c749d72d961',
  REACT_APP_API_URL: 'https://localhost:7006', //'https://as-mg-dev1-t1-weu-erealmapi-01.azurewebsites.net',
  REACT_APP_AZURE_REDIRECT_URL: 'http://localhost:3000/home',
  REACT_APP_AZURE_AUTHORITY:
    'https://login.microsoftonline.com/aa42167d-6f8d-45ce-b655-d245ef97da66',
  REACT_APP_AZURE_SCOPE: 'api://62607639-90ce-470d-96ce-35a5ab40a28a/user_impersonation',
  EXPOSURE_MENU: 'true',
  EXPOSURE_INTRADAY_MENU: 'true',
  EXPOSURE_HISTORICAL_MENU: 'true',
  EXPOSURE_ALERTRISK_USAGE_MENU: 'true',
  IMPORT_MENU: 'true',
  COUNTERPARTY_MENU: 'true',
  COUNTERPARTY_LIST_MENU: 'true',
  COUNTERPARTY_LIMITS_MENU: 'true',
  COUNTERPARTY_USAGE_MENU: 'false',
  REFERENCE_DATA_MENU: 'true',
  REFDATA_MENU: 'true',
  REFDATA_FUND_MENU: 'true',
  REFDATA_CP_MENU: 'true',
  REFDATA_RISK_MENU: 'true',
  REFDATA_ANALYSTS_MENU: 'true',
  RADAR_MENU: 'true',
  DATA_MANAGEMENT_MENU: 'true',
  DATA_MANAGEMENT_COUNTERPARTY_MENU: 'true',
  DATA_MANAGEMENT_FUND_MENU: 'true',
  DATA_MANAGEMENT_IMPORTSOURCES_MENU: 'true',
  DATA_MANAGEMENT_TRADINGLINES_MENU: 'true',
  REPORTS_MENU: 'true',
  REPORTS_FUND_MENU: 'true',
  REPORTS_AUDIT_MENU: 'true',
  REPORTS_LIMITS_MENU: 'true'
}

export const getConfig = () => {
  if (process.env.NODE_ENV === 'development') {
    return localConfig
  } else {
    return window.config
  }
}
